/**
 * R4: send theme forms' sign-ups to Klaviyo while the form still submits to Shopify as before.
 * <form data-klaviyo-list="LIST_ID" data-klaviyo-company="PUBLIC_KEY" data-klaviyo-source="Footer">
 * An optional checkbox [name="klaviyo_optin"] must be ticked (contact form consent).
 * Uses Klaviyo's public client subscriptions API (public site key only, no secret).
 * Fires on the submit-button click (and Enter-submit) rather than only on `submit`: Shopify's
 * hCaptcha intercepts the submit event, so a submit-only listener can miss real sign-ups.
 */
if (!window.maKlaviyoBound) {
  window.maKlaviyoBound = true; // loaded by footer + contact section: bind once
  const sent = new WeakMap(); // form -> last email sent, so click + submit don't double-post

  const send = (form) => {
    if (!form.checkValidity()) return;
    const optin = form.querySelector('[name="klaviyo_optin"]');
    const email = form.querySelector('input[type="email"]')?.value.trim();
    const { klaviyoList: list, klaviyoCompany: company, klaviyoSource: source } = form.dataset;
    if (!list || !company || !email || (optin && !optin.checked) || sent.get(form) === email) return;
    sent.set(form, email);
    fetch(`https://a.klaviyo.com/client/subscriptions/?company_id=${encodeURIComponent(company)}`, {
      method: 'POST',
      keepalive: true, // the Shopify form navigates away right after
      headers: { 'Content-Type': 'application/json', revision: '2024-10-15' },
      body: JSON.stringify({
        data: {
          type: 'subscription',
          attributes: {
            custom_source: source || 'Website form',
            profile: { data: { type: 'profile', attributes: { email } } },
          },
          relationships: { list: { data: { type: 'list', id: list } } },
        },
      }),
    }).catch(() => sent.delete(form));
  };

  document.addEventListener('click', (e) => {
    const btn = e.target.closest('form[data-klaviyo-list] [type="submit"]');
    if (btn) send(btn.form);
  }, true);
  document.addEventListener('submit', (e) => {
    const form = e.target.closest('form[data-klaviyo-list]');
    if (form) send(form);
  }, true);
}
